import useAxiosInterceptor from 'src/services/interceptor';
import { npcLogApiConstant } from '../constants';

class NpcLogService {
  private axiosInstance;

  constructor() {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- factory, not a React hook (matches laborHoursService)
    this.axiosInstance = useAxiosInterceptor();
  }

  getNpcEntries = (payload: any) => {
    return this.axiosInstance.get(`${npcLogApiConstant.getEntries}`, {
      params: payload,
    });
  };

  getActivityTypes = () => {
    return this.axiosInstance.get(`${npcLogApiConstant.activityTypes}`);
  };

  addNpcEntry = (payload: any) => {
    return this.axiosInstance.post(`${npcLogApiConstant.base}`, payload);
  };

  // Reviewer add-for-team (THIN-8187): create an entry on behalf of a therapist. Honours the
  // therapistUuid in the payload (the plain POST above ignores it and self-attributes); gated on
  // APPROVE_NPC in the service layer. Created NOT_VALIDATED like any other entry.
  addNpcEntryForTherapist = (payload: any) => {
    return this.axiosInstance.post(`${npcLogApiConstant.forTherapist}`, payload);
  };

  editNpcEntry = (payload: any) => {
    const { id, ...body } = payload;
    return this.axiosInstance.put(`${npcLogApiConstant.base}/${id}`, body);
  };

  deleteNpcEntry = (payload: any) => {
    return this.axiosInstance.delete(`${npcLogApiConstant.base}/${payload}`);
  };

  // ── Reviewer surface (THIN-7742) ──
  getTeamEntries = (payload: any) => {
    return this.axiosInstance.get(`${npcLogApiConstant.base}/team`, { params: payload });
  };

  getTeamEntriesEditable = (payload: any) => {
    return this.axiosInstance.get(`${npcLogApiConstant.base}/team`, { params: payload });
  };

  // action: 'approve' | 'decline' | 'reopen'
  reviewNpcEntry = (payload: any) => {
    const { id, action, declineReason } = payload;
    if (action === 'decline') {
      return this.axiosInstance.put(`${npcLogApiConstant.base}/${id}/decline`, { declineReason });
    }
    return this.axiosInstance.put(`${npcLogApiConstant.base}/${id}/${action}`);
  };

  // Bulk approve/decline in one transactional request (THIN-7818).
  // payload: { ids: string[], action: 'approve' | 'decline', declineReason? }
  reviewNpcBatch = (payload: any) => {
    return this.axiosInstance.put(`${npcLogApiConstant.base}/review-batch`, payload);
  };

  // Printable review report (THIN-7819) — returns the server-generated PDF url in response.data.data.
  // payload: { from?, to?, status?, therapistId? } (only defined keys are sent)
  getNpcReviewReportUrl = (payload: any) => {
    return this.axiosInstance.get(`${npcLogApiConstant.reviewReport}`, { params: payload });
  };
}

const npcLogService = new NpcLogService();

Object.freeze(npcLogService);

export default npcLogService;
